import { ChangeEvent, useEffect, useRef, useState } from 'react'
import Calendar from 'react-calendar'
import styled, { css } from 'styled-components'
import 'react-calendar/dist/Calendar.css'
import moment from 'moment'
import { BodyPortal } from '../portals/BodyPortal'

const Container = styled.div`
  position: relative;
`

const ItemContainer = styled.div<{ isOpen: boolean; top: number; left: number }>`
  cursor: pointer;
  width: 100%;
  position: absolute;
  z-index: 9999;
  ${(props) =>
    !props.isOpen &&
    css`
      display: none;
    `}
`

type Props = {
  name?: string
  className?: string
  value?: Date
  disabled?: boolean
  onChange?: (value: Date, e: React.ChangeEvent<HTMLInputElement>) => void | undefined
  maxDate?: Date
  minDate?: Date
  view?: 'month' | 'year' | 'decade' | 'century';
  dateFormat?: string
} & typeof defaultProps

const defaultProps = {
  dateFormat: 'DD/MM/YYYY'
}

export const ReactCalendar = (props: Props) => {
  const containerRef = useRef(null)
  const itemRef = useRef<HTMLDivElement>(null)
  const txtRef = useRef<HTMLInputElement>(null)
  const [isOpen, setIsOpen] = useState(false)
  const [containerSize, setContainerSize] = useState({ top: 0, left: 0 })
  const [selected, setSelected] = useState(new Date())

  const toggling = (event: React.MouseEvent<HTMLDivElement>) => {
    if (txtRef?.current && itemRef?.current) {
      const top = txtRef.current.getBoundingClientRect().bottom
      const left = txtRef.current.getBoundingClientRect().left
      setContainerSize({
        top: top,
        left: left,
      })
    }

    setIsOpen(true)
    event.stopPropagation()
  }

  useEffect(() => {
    //
    // setContainerSize({
    //   top: itemRef?.current ? itemRef.current.offsetWidth : 0, // Consider border
    //   left: itemRef?.current ? itemRef.current.offsetHeight : 0,
    // })

    const handleClickOutside = (e: any) => {
      if (!e.target) return;
      for (let index = 0; index < e.target.classList.length; index++) {
        if (e.target.classList[index].indexOf('react-calendar') >= 0) {
          return;
        }
      }
      setIsOpen(false)
    }
    document.addEventListener('click', handleClickOutside)
    // return () => {
    //   document.addEventListener('click', handleClickOutside)
    // }
  }, [])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => { }

  const handleSelected = (value: Date, event: any) => {
    setSelected(value)
    setIsOpen(false)
    props.onChange?.(value, event)
    return
  }

  return (
    <>
      <div className='d-flex '>
        <span className='me-5'>
          <input
            type='text'
            name={props.name}
            className={props.className}
            ref={txtRef}
            value={props.value ? moment(props.value).format(props.dateFormat) : ""}
            //value={moment(selected).format("DD/MM/YYYY")}
            onChange={() => handleChange}
            onClick={(e: React.MouseEvent<HTMLDivElement>) => toggling(e)}
            disabled={props.disabled}
          />
        </span>
        <span className='mt-5' onClick={(e: React.MouseEvent<HTMLDivElement>) => toggling(e)}>
          <i className="fa-solid fa-calendar-days fa-2xl"></i>
        </span>
      </div>
      <Container ref={containerRef}>
        <ItemContainer isOpen={isOpen} ref={itemRef} {...containerSize}>
          <Calendar
            value={props.value ? new Date(moment(props.value).format('YYYY-MM-DD')) : undefined}
            onChange={(value: Date, event: ChangeEvent<HTMLInputElement>) =>
              handleSelected(value, event)
            }
            onClickMonth={(value: Date, event: any) =>
              handleSelected(value, event)
            }
            maxDate={props.maxDate}
            minDate={props.minDate}
            view={props.view}
          />
        </ItemContainer>
      </Container>
      {/* <BodyPortal>
        
      </BodyPortal> */}
    </>
  )
}

ReactCalendar.defaultProps = defaultProps
